import { render, staticRenderFns } from "./Tiktok.vue?vue&type=template&id=2f2b436f"
import script from "./Tiktok.vue?vue&type=script&lang=js"
export * from "./Tiktok.vue?vue&type=script&lang=js"
import style0 from "./Tiktok.vue?vue&type=style&index=0&id=2f2b436f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports